<template>
  <section class="member-signup">
    <LanguageSelect></LanguageSelect>

    <div class="row">
      <div class="col-xs-12">
        <h2 class="headline-lg medium">{{ d.personalInformationTitle }}</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <div class="field-wrapper half required">
          <label for="personal-details_firstname">{{ d.firstname }}*</label>
          <input
            type="text"
            id="personal-details_firstname"
            v-model="values.firstname"
            :placeholder="d.placeholdertextbox"
            @blur="v$.values.firstname.$touch"
          />

          <div
            class="input-errors"
            v-for="error of v$.values.firstname.$errors"
            :key="error.$uid"
          >
            <div v-if="error.$validator == 'forbiddenCharsAndNumbers' && !error.$response" class="error-msg">{{ d.errorforbiddencharacters }}</div>
            <div class="error-msg">{{ d.errorfirstname }}</div>
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6">
        <div class="field-wrapper half required">
          <label for="personal-details_lastname">{{ d.lastname }}*</label>
          <input
            type="text"
            id="personal-details_lastname"
            v-model="values.lastname"
            :placeholder="d.placeholdertextbox"
            @blur="v$.values.lastname.$touch"
          />

          <div
            class="input-errors"
            v-for="error of v$.values.lastname.$errors"
            :key="error.$uid"
          >
            <div v-if="error.$validator == 'forbiddenCharsAndNumbers' && !error.$response" class="error-msg">{{ d.errorforbiddencharacters }}</div>
            <div class="error-msg">{{ d.errorlastname }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <label for="personal-details_cpr">{{ d.cpr }}*</label>
        <input
          type="text"
          id="personal-details_cpr"
          v-model="values.cpr"
          :placeholder="d.placeholdernodash"
          @blur="v$.values.cpr.$touch"
        />

        <HelperTip :rte="d.noCprHelperTip"></HelperTip>

        <div class="error-wrapper">
          <div
            class="input-errors"
            v-for="error of v$.values.cpr.$errors"
            :key="error.$uid"
          >
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg" >
              {{ d.errorcpr }}
            </div>
            <div v-if="error.$validator == 'cprValidation' && !error.$response" class="error-msg" >
              {{ d.errorcprformat }}
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-6">
        <label for="personal-details_emailaddress">{{ d.emailaddress }}*</label>
        <input
          type="text"
          id="personal-details_emailaddress"
          v-model="values.emailaddress"
          :placeholder="d.placeholdertextbox"
          @blur="v$.values.emailaddress.$touch"
        />

        <div
          class="input-errors"
          v-for="error of v$.values.emailaddress.$errors"
          :key="error.$uid"
        >
          <div
            v-if="error.$validator == 'required' && !error.$response"
            class="error-msg"
          >
            {{ d.erroremail }}
          </div>
          <div v-if="error.$validator == 'email' && !error.$response" class="error-msg">
            {{ d.erroremailformat }}
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6">
        <label for="personal-details_phone">{{ d.phone }}*</label>
        <div class="personal-details_phonearea">
          <input
            type="text"
            id="personal-details_phonearea"
            v-model="values.phonearea"
            @blur="v$.values.phonearea.$touch"
            autocomplete="tel-country-code"
            :aria-label="culture === 'dk' ? 'Landekode' : 'Country code'"
          />
        </div>
        <input
          type="tel"
          id="personal-details_phone"
          v-model="values.phone"
          :placeholder="d.placeholdernospace"
          @blur="v$.values.phone.$touch"
          autocomplete="tel"
        />

        <div class="input-errors" v-for="error of v$.values.phonearea.$errors" :key="error.$uid" >
          <div v-if="error.$validator == 'required' && !error.$response" class="error-msg" >
            {{ d.errorphonenocountrycode }}
          </div>
          <div v-if="error.$validator == 'minLength' && !error.$response" class="error-msg" >
            {{ d.errorphonecountrycodetooshort }}
          </div>
          <div v-if="error.$validator == 'maxLength' && !error.$response" class="error-msg" >
            {{ d.errorphonecountrycodetoolong }}
          </div>
          <div v-if="error.$validator == 'numeric' && !error.$response" class="error-msg">
            {{ d.errorphonecountrynumeric }}
          </div>
        </div>

        <div class="input-errors" v-for="error of v$.values.phone.$errors" :key="error.$uid">
          <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
            {{ d.errorphonenonum }}
          </div>
          <div v-if="error.$validator == 'numeric' && !error.$response" class="error-msg">
            {{ d.errorphonenumeric }}
          </div>
          <div v-if="error.$validator == 'minLength' && !error.$response" class="error-msg">
            {{ d.errorphonelength }}
          </div>
          <div v-if="error.$validator == 'maxLength' && !error.$response" class="error-msg">
            {{ d.errorphonelength }}
          </div>
          <div v-if="error.$validator == 'phoneDummyValidation' && !error.$response" class="error-msg">
            {{ d.errorphonenotrecognized }}
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import HelperTip from '../FormComponents/HelperTip.vue'
import LanguageSelect from "../FormComponents/LanguageSelect.vue";
import { cultureMixin } from '../../util/cultureMixin.js';

export default {
  components: {
    HelperTip,
    LanguageSelect
  },
  mixins: [cultureMixin],
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    return {
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,
      dictionaryData: {},

      noCprBirthday: null,

      dictionaryCountryList: [],
      dictionaryCountryIsLoading: false,
      dictionaryCountryError: null,

      dictionaryGenders: [],
      dictionaryGenderIsLoading: false,
      dictionaryGenderError: null,

      date: new Date(),
    };
  },
  computed: {
    cprFormatted: {
      get() {
        return this.values.cpr;
      },
      set(value) {
        const formatted = value.replace("-", "");
        this.values.cpr = formatted;
      },
    },
    //
    // This function is not used - needs to be streamlined
    phoneAreaFormatted: {
      get() {
        return this.values.phonearea;
      },
      set(value) {
        const formatted = value.replace(/[^0-9]/g, "");
        this.values.phonearea = "+ " + formatted;
      },
    },
    // This function is not used - needs to be streamlined
    //
  },
  watch: {
    "values.emailaddress"(value){
      if(value !== null)
        this.values.emailaddress = value.trim();
    },
    "values.cpr"(newValue) {
      this.values.cpr = newValue.replace("-", "");
    },
  },
  beforeUnmount() {
    this.emitter.off('culture-change', this.loadData);
  },
  methods: {
    loadData(){
      //
      // LOADS DATA
      this.GetCountryData();
      this.GetGenderData();
    },
    merge(){

      console.log("merge called from personDetails", this.merges.userDetails);

      if (this.merges.userDetails?.firstName) {
        this.values.firstname = this.merges.userDetails.firstName;
      }

      if (this.merges.userDetails.lastName) {
        this.values.lastname = this.merges.userDetails.lastName;
      }

      if (this.merges.userDetails.emailPrivate) {
        this.values.emailaddress = this.merges.userDetails.emailPrivate;
      }

      if (this.merges.userDetails.cpr) {
        this.values.cpr = this.merges.userDetails.cpr;
      }

      // Extract phone and country code
      let phoneRaw = '';
      if (this.merges.userDetails.telPrivate) {
        phoneRaw = this.merges.userDetails.telPrivate.replace(/\s+/g, '');
      } else if (this.merges.userDetails.mobile) {
        phoneRaw = this.merges.userDetails.mobile.replace(/\s+/g, '');
      }

      // Match valid country codes using ITU E.164 standard (non-greedy)
      const match = phoneRaw.match(/^(?:\+|00)(1|7|2[07]|3[0123469]|4[013456789]|5[12345678]|6[0123456]|8[1246]|9[0123458]|(?:2[12345689]|3[578]|42|5[09]|6[789]|8[035789]|9[679])\d)(\d+)$/);
      if (match) {
        this.values.phonearea = match[1];
        this.values.phone = match[2];
      } else {
        this.values.phonearea = '';
        this.values.phone = phoneRaw;
      }
    },
    ResetValidation() {
      this.v$.values.country.$reset();
      this.v$.values.gender.$reset();
      this.v$.values.birthday.$reset();
    },
    SetDate(field) {
      if (!field || !this.birthday) return;
      this.values.birthday = new Date(this.birthday)?.toISOString();
    },
    SetValue(event, field) {
      console.log(event);
      if (!event) return;

      switch (field) {
        case "country":
          this.values.country = event.name;
          break;
        case "birthday":
          this.values.birthday = event.name;
          break;
        case "gender":
          this.values.gender = event.name;
      }
    },
    dateFormat(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
    async GetCountryData() {
      this.dictionaryCountryIsLoading = true;
      this.dictionaryCountryError = null;

      try {
        const dataCountries = await axios.get(
          `/umbraco/api/signup/GetCountryList?culture=${this.culture}`
        );
        this.dictionaryCountryList = dataCountries.data;
      } catch (error) {
        this.dictionaryCountryError =
          "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryCountryError);
      } finally {
        this.dictionaryCountryIsLoading = false;
      }
    },
    async GetGenderData() {
      this.dictionaryGenderIsLoading = true;
      this.dictionaryGenderError = null;

      try {
        const dataGenders = await axios.get(`/umbraco/api/signup/GetGenderList`);
        this.dictionaryGenders = dataGenders.data;
      } catch (error) {
        this.dictionaryGenderError =
          "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryGenderError);
      } finally {
        this.dictionaryGenderIsLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();

    this.emitter.on("culture-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.d = this.store[this.store.currentCulture].dictionary;
      this.culture = this.store.currentCulture;

      // LOADS DATA ON LANGUAGE CHANGE
      this.loadData();

      this.v$.$reset();

      
    });
    if (this.merges) {
      this.merge();
    }

  },
  validations() {
    return this.validations.personalDetails;
  },
};
</script>

<style scoped lang="postcss">
.input-errors {
  color: red;
  margin-top: -15px;
  + .input-errors {
    margin-top: 0;
  }
}

.no-margin {
  margin-top: 0;
}

.no-bottom-margin input {
  margin-bottom: 0;
}

#personal-details_cpr {
  margin-bottom: 5px;
}

#personal-details_nocpr {
  margin-left: 0;
  margin-right: 7px;
}

label#personal-details_nocpr,
#personal-details_nocpr {
  float: left;
}

.personal-details_phonearea {
  width: 15%;
  margin-right: 20px;
  float: left;
  position: relative;

  &:before {
    content: "+";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(calc(-50% - 8px));
  }
}

#personal-details_phonearea {
  width: 100%;
  padding-left: 10px;
  margin-bottom: 0;
}

#personal-details_phone {
  width: calc(85% - 20px);
}

.multiselect {
  z-index: 1000;
}

.member-signup {
  position: relative;
  padding-top: var(--grid-gutter-2);
  @media screen and (min-width: 1400px) {
    padding-top: 0;
    margin-top: var(--grid-gutter-2);
  }
  .headline-lg {
    margin-bottom: 58px;
  }
  label {
    margin-bottom: 14px;
  }
  input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]):not([type="file"]):not([type="range"]) {
    padding-bottom: 8px;
  }
  .check-after-input {
    margin-top: 11px;
  }
  .error-wrapper {
    padding-top: 11px;
    margin-bottom: 49px;
  }
}
</style>